module.exports = __webpack_public_path__ + "static/media/29BDOS5.5108c490.jpg";